import { render, staticRenderFns } from "./leftPageYJ.vue?vue&type=template&id=27e64e7a&scoped=true&"
import script from "./leftPageYJ.vue?vue&type=script&lang=js&"
export * from "./leftPageYJ.vue?vue&type=script&lang=js&"
import style0 from "./leftPageYJ.vue?vue&type=style&index=0&id=27e64e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e64e7a",
  null
  
)

export default component.exports